var _style, _defs, _defs2, _rect, _defs3, _defs4, _defs5, _defs6, _defs7, _rect2, _defs8, _defs9, _rect3, _defs10, _defs11, _rect4, _defs12, _defs13, _rect5, _defs14, _defs15, _rect6, _defs16, _defs17, _rect7, _defs18, _defs19, _rect8, _defs20, _defs21, _rect9, _defs22, _defs23, _rect10, _defs24, _defs25, _rect11, _defs26, _defs27, _rect12, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskDocFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.8 258",
    style: {
      enableBackground: "new 0 0 275.8 258"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{opacity:0.4;clip-path:url(#SVGID_4_);fill:#A0C3CD;}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);enable-background:new    ;}\n\t.st4{clip-path:url(#SVGID_10_);}\n\t.st5{clip-path:url(#SVGID_12_);}\n\t.st6{clip-path:url(#SVGID_14_);fill:#D4A181;}\n\t.st7{clip-path:url(#SVGID_16_);}\n\t.st8{clip-path:url(#SVGID_18_);fill:#222045;}\n\t.st9{clip-path:url(#SVGID_20_);}\n\t.st10{clip-path:url(#SVGID_22_);fill:#997659;}\n\t.st11{clip-path:url(#SVGID_24_);}\n\t.st12{clip-path:url(#SVGID_26_);fill:#B28B66;}\n\t.st13{clip-path:url(#SVGID_28_);}\n\t.st14{clip-path:url(#SVGID_30_);fill:#69A1AC;}\n\t.st15{clip-path:url(#SVGID_32_);}\n\t.st16{clip-path:url(#SVGID_34_);fill:#89C5CC;}\n\t.st17{clip-path:url(#SVGID_36_);}\n\t.st18{clip-path:url(#SVGID_38_);fill:#997659;}\n\t.st19{clip-path:url(#SVGID_40_);}\n\t.st20{clip-path:url(#SVGID_42_);fill:#5C64AB;}\n\t.st21{clip-path:url(#SVGID_44_);}\n\t.st22{clip-path:url(#SVGID_46_);fill:#8A90C7;}\n\t.st23{clip-path:url(#SVGID_48_);}\n\t.st24{opacity:0.1;clip-path:url(#SVGID_50_);fill:#010202;}\n\t.st25{clip-path:url(#SVGID_52_);}\n\t.st26{clip-path:url(#SVGID_54_);fill:#FFFFFF;}\n\t.st27{fill:#0D8337;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 150.3,
    cy: 132.5,
    r: 125.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -575.2,
    y: -255,
    width: 1440,
    height: 1350
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 2,
    className: "st1",
    width: 261,
    height: 261
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M132.1,0l0,6.6c6.2-1,12.6-1.6,19.1-1.6c67.1,0,121.5,56.3,121.5,125.7s-54.4,125.7-121.5,125.7 c-25.8,0-49.7-8.3-69.4-22.5c-2,14.2-12.2,12.1-24.6,12.1c-13.8,0-25-0.5-25-17.1c0-13.6,7.4-25,17.6-28.8 c-12.7-19.9-20.1-43.7-20.1-69.3c0-32.9,12.2-62.8,32.2-85.2L0,45.5V0H132.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -575.2,
    y: -255,
    width: 1440,
    height: 1350
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 9.8,
    y: 5,
    width: 232,
    height: 369
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M149.6,46.5c5,9.3,4.4,32.9-2.1,34.5c-2.6,0.7-8.1-1-13.6-4.3l3.5,24.8h-20.7l7.1-33.2 c-4-4.7-6.7-10.4-6.2-16.8C118.9,33.1,144.6,37.2,149.6,46.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111.7,
    y: 33.6,
    className: "st6",
    width: 46.2,
    height: 72.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M137.8,35.8c-2.7-0.4-10.1-0.8-11.4-0.8c-0.9,0-1.8,0.2-2.3-0.6c-0.4-0.6-0.3-1.7-0.4-2.5 c-0.1-0.9-0.4-1.7-0.6-2.6c-0.6-2.5-1.5-4.8-2.8-7c-2.4-4.1-5.8-7.3-10.2-9.2c-4.8-2.1-10.3-2.5-15.5-2.1 c-5.5,0.4-10.6,2.3-15.8,4c-5,1.6-10.2,2.3-15.4,1.5c-5.3-0.8-9.2-3.7-13.7-6.4C45.3,7.4,40.1,5.6,34.7,6 c-5,0.4-9.6,2.5-13.8,5.2c-3.9,2.6-7.1,5.7-8.9,10.1c-1.9,4.7-1.9,9.9,1.3,14c4.6,6,13.2,7.6,20.4,7.4 c4.1-0.1,8.2-0.8,12.1-2.2c5.2-1.8,9.7-4.9,14.6-7.5c2.3-1.2,4.7-2.2,7.1-2.9c2.4-0.7,4.8-1,7,0.5c2.3,1.5,4.4,3,7,4 c2.5,0.9,5.2,1.4,7.9,1.4c5.2,0,10.4-1.7,15.5-2.8c4.2-0.9,8.6-1.8,12.8-0.9c1.8,0.4,4.3,1.1,5,2.9 c-10.7,1.9-15,15.2-11.9,24.9c1.6,5.3,11.5,11.4,15.3,8.6c2.4-1.7,1-4,0-5.6c-1.8-2.9-2.4-6.6,0.9-8.7c2.9-1.7,6,2.4,6,2.4 c0.8-0.1,7.7-4,12.5-9.6c4.7,0.3,5.4-2.8,4.3-5.3C148.6,39.6,141.6,36.4,137.8,35.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 0.9,
    className: "st8",
    width: 149.5,
    height: 73.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_19_",
    points: "102.9,175.5 135.4,281.4 151.1,371.5 163.4,371.5 146.8,175.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 97.9,
    y: 170.5,
    className: "st10",
    width: 70.5,
    height: 206
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M91.3,175.5c2.2,58.1-0.4,88.1-0.9,93.4c-0.5,5.3-7.2,39.5-23.2,104.3l13.1-4.5 c25.3-59.4,33.9-90.3,36.8-98.1c2.9-7.8,10.6-39.5,23.1-95.1H91.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2,
    y: 170.5,
    className: "st12",
    width: 83,
    height: 207.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_27_",
    points: "98.6,175.5 112.4,229.5 154.6,229.5 148.3,175.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 170.5,
    className: "st14",
    width: 65.9,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M90.9,175.5c-4.5,13.6-5.4,31.6-2.6,54h43l11.8-54H90.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 170.5,
    className: "st16",
    width: 66.4,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M238,127.6c-0.2,0.2-0.5,0.4-0.7,0.6l-0.5,0.4c-3.4,2.9-6.4,5.8-5.8,7.4c0.7,1.7,4.2,1.1,4.8,3.7 c0.4,1.7-5.4,2-17.3,0.8l-27.6,10.9l-6.1-15.2l34-4.6c6.8-3.8,13.1-6.3,18.8-7.7l0.1,0h0.2C239.5,123.9,241.6,124.6,238,127.6 z M77.9,144l18.9,0.1c-20.7,46.5-31.5,70.9-32.4,73.1c-2,4.9,2.2,12.5,4,16.5c-3,1.3-4.3-0.5-5.8-2.2l-0.3-0.3 c-1.4-1.5-3.1-2.7-6.6-1.1c-1.2,0.6-2.4,1.2-3.6,1.9l-0.5,0.3c-0.2,0.1-0.4,0.2-0.5,0.3l-0.5,0.3l-0.5,0.3 c-4.4,2.5-8.5,4.3-14,0.9c-1-0.6-2-2.8,0.5-4.6c6.3-4.3,15.5-11.9,16.7-14.4C55,211.6,63.2,187.9,77.9,144z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 118.8,
    className: "st18",
    width: 215,
    height: 122
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M129.6,84.2l14.8,1c3.6,32.9,23.5,53.7,67.9,46.6l5.9,42.3c-41.5,5.4-77.9-11.2-85.3-56.1 C130.9,106.4,129.4,94.3,129.6,84.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 126.4,
    y: 77.4,
    transform: "matrix(8.715558e-02 -0.9962 0.9962 8.715558e-02 28.7581 292.1509)",
    className: "st20",
    width: 94.8,
    height: 106
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M122.3,79.9L122.3,79.9l22.4,5.1c0,26.9,6,47,11.8,66.4l0.5,1.7c0.2,0.8,0.5,1.7,0.7,2.5l0.5,1.7 c1.9,6.3,3.6,12.6,5.1,19.1l-60.5,0c-0.9,9.8-1.4,19.8-1.6,30.1H55.9c10.3-54.5,31.9-96.7,65-126.5H122.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9,
    y: 74.9,
    className: "st22",
    width: 117.4,
    height: 136.5
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    d: "M112.4,121.5c-1.6,24-0.6,42.3,2.8,54.9l-12.3,0c1.7-18.9,4.5-36.8,9.2-53.7L112.4,121.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: 9.8,
    y: 5,
    width: 263,
    height: 253
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 97.8,
    y: 116.5,
    className: "st24",
    width: 22.3,
    height: 64.9
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_51_",
    cx: 232.8,
    cy: 57.5,
    rx: 30.1,
    ry: 35.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -575.2,
    y: -255,
    width: 1440,
    height: 1350
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 197.6,
    y: 17,
    className: "st26",
    width: 70.3,
    height: 81
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M236.3,93.9c-19.3,0-34.9-15.6-34.9-34.9s15.6-34.9,34.9-34.9s34.9,15.6,34.9,34.9S255.5,93.9,236.3,93.9z  M258.1,51.6c0.9-0.9,0.9-2.3,0-3.2l-3.2-3.2c-0.9-0.9-2.3-0.9-3.2,0l-21.1,21.1l-9.9-9.9c-0.9-0.9-2.3-0.9-3.2,0l-3.2,3.2 c-0.9,0.9-0.9,2.3,0,3.2l14.6,14.6c0.9,0.9,2.3,0.9,3.2,0L258.1,51.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskDocFeedback);
export default __webpack_public_path__ + "static/media/ask-doc-feedback.28c091f168723f854d64f85c54c0aebc.svg";
export { ForwardRef as ReactComponent };